<template>
  <main-template ref="main_template">
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <span>Взаиморасчёты</span>
        </h1>
      </div>



      <div class="page_content mutual-settlements">
        <div class="top">
          <div class="left">
            <standart-filed
                id="date" title="Период от" type="date" placeholder="01.01.2025"
                :value="period.from"
                @updated="period.from = $event"
                error-text=""
            >
            </standart-filed>
            <standart-filed
                id="date" title="Период до" type="date" placeholder="01.01.2025"
                :value="period.to"
                @updated="period.to = $event"
                error-text=""
            >
            </standart-filed>
            <dropdown-filed
                title="Контрагент"
                c_style="white"
                :current='current_counterparty'
                :list="counterparties"
                @change="setCounterparty($event)"
            >
            </dropdown-filed>
          </div>
          <div class="right">
            <standart-button @click="download_excel()" text="Скачать в excel"></standart-button>
            <standart-button @click="clear()" text="Сбросить"></standart-button>
            <standart-button @click="apply()" style_type="prime" text="Применить"></standart-button>
          </div>
        </div>
        <div class="content">
          <mutualsettlements-table ref="mutualsettlements"></mutualsettlements-table>
        </div>
      </div>


    </template>
  </main-template>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue';
import StandartFiled from "@/components/share/StandartField";
import DropdownFiled from "@/components/share/DropdownField";
import StandartButton from "@/components/share/StandartButton";
import MutualsettlementsTable from "@/components/mutual_settlements/MutualsettlementsTable";
import axios from "axios";





export default {
  name: 'MyOrdersView',
  components: {
    MutualsettlementsTable,
    StandartButton,
    DropdownFiled,
    StandartFiled,
    MainTemplate,
  },
  data() {
    return{
      period : {
        from : "",
        to : ""
      },
      current_counterparty : {},
      counterparties : [],
      block_apply: false
    }
  },
  mounted() {
    this.loadData();
  },
  methods : {
    loadData : async function() {
      let res = await axios.get(window.api_url + "mutual_settlements/setup");

      this.current_counterparty = res.data.data.counterparties[0];
      this.counterparties = res.data.data.counterparties;

      this.period = res.data.data.last_quarter_period;
    },
    setCounterparty : function(counterparty_id) {
      for(let counterparty of this.counterparties)
      {
        if(counterparty.id == counterparty_id) {
          this.current_counterparty = counterparty;
        }
      }
    },
    download_excel : async function() {

      let res = await axios.get(
          window.api_url + "mutual_settlements/download?from="+this.period.from+"&to="+this.period.to
          +"&counterparty="+this.current_counterparty.id+"&check=y"
      );

      if(res.data.status == "fail") { return; }

      window.open(
          window.api_url
          + "mutual_settlements/download?from="
          +this.period.from+"&to="+this.period.to
          + "&counterparty="+this.current_counterparty.id
      );
    },
    clear : async function() {
      this.period.from = "";
      this.period.to = "";
      this.current_counterparty = this.counterparties[0];
      this.$refs.mutualsettlements.mutualsettlementsList = [];
    },
    apply : async function() {
      this.$refs.mutualsettlements.mutualsettlementsList = [];

      if(this.block_apply) {
        return;
      }

      this.block_apply = true;

      this.$refs.main_template.active_preloader = true;

      let res = await axios.get(
          window.api_url + "mutual_settlements/get?from="+this.period.from+"&to="+this.period.to
          +"&counterparty="+this.current_counterparty.id
      );

      if(res.data.status == "success") {
        this.$refs.mutualsettlements.mutualsettlementsList = res.data.data.result.list;
        this.$refs.mutualsettlements.mutualsettlementsTotal = res.data.data.result.total;
      }
      else if(res.data.status == "fail") {
        if(res.data.code == 1) {
          alert(res.data.description);
        }
      }

      this.$refs.main_template.active_preloader = false;

      this.block_apply = false;
    }
  }
}
</script>

<style scoped>

.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 14px;
  align-items: end;
  flex-wrap: wrap;
}

.top .left {
  display: flex;
  gap: 8px;
}

.top .right {
  display: flex;
  gap: 10px;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .top {
    flex-direction: column;
    margin-bottom: 30px;
    align-items: unset;
  }

  .top .left {
    flex-direction: column;
  }

  .top .right {
    flex-direction: column;
  }

  .top .right button {
    width: 100%;
  }
}
</style>



<style>

.top .standart_field {
  width: 262px;
}

.top .standart_field input{
  height: 50px;
}

.top .standart_field input{
  background: var(--White);
}

.top .dropdown_field {

}

.top .dropdown_field input{
  height: 50px;
}

.top .right .standart_button {
  width: 168px;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .top .standart_field {
    width: 100%;
  }

  .top .dropdown_field {
    width: 100%;
  }
}

</style>
